import { Templates } from '@hellohair/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NextQuestionSelect, StepField } from '../_shared/fields';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

const Confirmation: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataConfirmation>(survey, index);

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField label={t('editor.field.title')} value={draft.title} onChange={(value) => set('title', value)} />
          <StepField
            label={t('editor.field.message')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />
          <StepField
            label={t('editor.field.extraPrompt')}
            value={draft.extraPrompt}
            onChange={(value) => set('extraPrompt', value)}
            multiline
          />
          <StepField
            label={t('editor.field.extra')}
            value={draft.extra}
            onChange={(value) => set('extra', value)}
            multiline
          />
        </>
      }
      logic={
        <NextQuestionSelect
          steps={survey.steps}
          value={draft.followerId}
          onChange={(followerId) => set('followerId', followerId)}
        />
      }
      settings={
        <StepField label={t('editor.field.buttonLabel')} value={draft.next} onChange={(value) => set('next', value)} />
      }
    />
  );
};

export default Confirmation;
